import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgForm } from '@angular/forms';


@Component({
  selector: 'app-home-card-editor',
  templateUrl: './home-card-editor.component.html',
  styleUrls: ['./home-card-editor.component.css']
})
export class HomeCardEditorComponent implements OnInit {
  @Input() Card: any;
  @Input() Saving: boolean;
  @Output() save: EventEmitter<any> = new EventEmitter();
  @Output() default: EventEmitter<null> = new EventEmitter();
  constructor() { }

  ngOnInit() {
    if (this.Card.Title === '') {
      this.Card.Title = this.Card.DefaultTitle;
    }
    if (this.Card.Description === '') {
      this.Card.Description = this.Card.DefaultDescription;
    }
  }

  saveCardConfig() {
    this.save.emit(this.Card);
  }

  defaultCardConfig(form: NgForm) {
    this.default.emit(this.Card);
    this.Card.Title = this.Card.DefaultTitle;
    this.Card.Description = this.Card.DefaultDescription;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/home-card-editor/home-card-editor.component.ts